let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hC8BQ")).then(() => parcelRequire('hU8Wg'));